import { render, staticRenderFns } from "./OffDayLegend.vue?vue&type=template&id=706b95aa&"
import script from "./OffDayLegend.vue?vue&type=script&lang=js&"
export * from "./OffDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports